const instrumentStatuses = Object.freeze({
  Draft: 1,
  Completed: 2,
});

export default instrumentStatuses;
